import { useEffect, useRef, useState } from 'react';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { AUTHENTICATION, GLOBAL_CONSTANTS, PASDWORDREGEX, ROUTES, S3DataGetApi, TOASTER_CONFIGS } from '../../constants';
import { Button, TextField, Box, Grid, FormControl, InputLabel, Select, MenuItem, FormHelperText, IconButton, Badge, Avatar, Typography, Stack, Modal, Container, CssBaseline } from '@mui/material';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';
import Logo from "../../assets/logo.svg";

import { PhotoCamera } from '@material-ui/icons';
import './Profile.scss'
import { useChangePasswordMutation, useDepartmentDropdownListQuery, useProfileDetailsQuery, useProfileUpdateMutation } from '../../service/apiSlices/accessApiService';
import { nullUndefinedEmptyCheck } from '../../utils/helper';
import { useResetPasswordMutation } from '../../service/apiSlices/authService';
import PhoneInput from 'react-phone-input-2';

// Define the style object for the modal
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    outline: 'none',
    bgcolor: 'background.paper',
    border: 'none',
    boxShadow: 24,
};


const ProfileComponent = () => {
    const navigate = useNavigate();
    const { id } = useParams();
    const formikRef = useRef<any>(null);
    const docUploadRef = useRef<any>(null);
    /*Admin or Super-Admin Sidebar Condition*/
    const isSuperAdminToken = sessionStorage.getItem(AUTHENTICATION.SHARED.SUPER_ADMIN);
    const isAdminToken = sessionStorage.getItem(AUTHENTICATION.SHARED.NORMAL_ADMIN);
    const { data: getData } = useProfileDetailsQuery('');
    const { data: DeparmentList } = useDepartmentDropdownListQuery('');
    const [profileUpdateApi] = useProfileUpdateMutation()
    const [docOpen, setDocOpen] = useState<boolean>(false);
    const [countryFlag, setCountryFlag] = useState<any>('');
    const [initialValues, setInitialValues] = useState<any>({});
    const Patchvalue = getData?.result?.data[0];

    useEffect(() => {
        if (isSuperAdminToken === "true") {
            setInitialValues({
                profileImage: nullUndefinedEmptyCheck(Patchvalue?.profile_image) ? Patchvalue?.profile_image : '',
                firstname: nullUndefinedEmptyCheck(Patchvalue?.firstname) ? Patchvalue.firstname : '',
                lastname: nullUndefinedEmptyCheck(Patchvalue?.lastname) ? Patchvalue.lastname : '',
                email: nullUndefinedEmptyCheck(Patchvalue?.email) ? Patchvalue?.email : '',
            });
        } else {
            setInitialValues({
                profileImage: nullUndefinedEmptyCheck(Patchvalue?.profile_image) ? Patchvalue.profile_image : '',
                firstname: nullUndefinedEmptyCheck(Patchvalue?.firstname) ? Patchvalue.firstname : '',
                lastname: nullUndefinedEmptyCheck(Patchvalue?.lastname) ? Patchvalue.lastname : '',
                email: nullUndefinedEmptyCheck(Patchvalue?.email) ? Patchvalue.email : '',
                department_id: nullUndefinedEmptyCheck(Patchvalue?.department) ? Patchvalue?.department : '',
                emirates_id: nullUndefinedEmptyCheck(Patchvalue?.emirates_id) ? Patchvalue?.emirates_id : '',
                employee_id: nullUndefinedEmptyCheck(Patchvalue?.employee_id) ? Patchvalue?.employee_id : '',
                phone_number: nullUndefinedEmptyCheck(Patchvalue?.phone_number) ? Patchvalue?.phone_number : '',
            })
        }
    }, [getData, isSuperAdminToken, Patchvalue, initialValues]);

    const [uid, setUid] = useState("");
    const [token, setToken] = useState("");
    const [Visibility, setVisibility] = useState('password')
    const [VisibilityConfirm, setVisibilityConfirm] = useState('password')
    const [loginInfo, setLoginInfo] = useState({
        password: '',
        confirm_password: '',
    });
    const [error, setError] = useState<any>({
        password: '',
        confirm_password: '',
    })
    const [errorMsg, setErrorMsg] = useState({
        password: '',
        confirm_password: '',
    })
    useEffect(() => {
        let paramData = id?.split("-**-") ?? [];
        setUid(paramData[0]);
        setToken(paramData[1]);
    }, [id]);

    //handle input changes 
    const kychandleChange = (name: any, value: any) => {
        setLoginInfo({ ...loginInfo, [name]: value });

        // Validate the fields as the user types
        if (name === 'password' || name === 'confirm_password') {
            validatePasswords(name, value);
        }
    };

    const validatePasswords = (name: any, value: any) => {
        let passwordError = '';
        let confirmPasswordError = '';
        if (name === 'password') {
            if (value.length < 8) {
                passwordError = AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_REQUIRED;
            } else if (!PASDWORDREGEX.test(value)) {
                passwordError = 'Password must contain at least one capital letter and one special character';
            }
        }

        if (name === 'confirm_password' && value !== loginInfo.password) {
            confirmPasswordError = AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_MISMATCH;
        }

        setErrorMsg({
            ...errorMsg,
            password: passwordError,
            confirm_password: confirmPasswordError,
        });

        setError({
            ...error,
            password: !!passwordError,
            confirm_password: !!confirmPasswordError,
        });
    };

    const [ResetPasswordApiCall] = useChangePasswordMutation();

    const handleSubmit = (event: any) => {
        event.preventDefault();

        if (loginInfo.password.length < 8) {
            setErrorMsg({ ...errorMsg, password: AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_REQUIRED });
            setError({ ...error, password: true });
            return;
        }

        if (loginInfo.password !== loginInfo.confirm_password) {
            setErrorMsg({ ...errorMsg, confirm_password: AUTHENTICATION.FIELDS_ERROR_MESSAGES.PASSWORD_MISMATCH });
            setError({ ...error, confirm_password: true });
            return;
        }

        if (!error.password && !error.confirm_password && nullUndefinedEmptyCheck(loginInfo.password)
            && nullUndefinedEmptyCheck(loginInfo.confirm_password)) {

            var payload = {
                password: loginInfo.password,
                confirm_password: loginInfo.confirm_password,
                uid: uid,
                token: token
            }

            ResetPasswordApiCall(payload)
                .unwrap()
                .then((response: any) => {
                    // console.log('response', response)
                    toast.success(response?.message, TOASTER_CONFIGS);
                    logout();
                    setDocOpen(false)
                })
                .catch((error: any) => {
                    toast.error(error?.data?.message, TOASTER_CONFIGS);
                    setDocOpen(false)
                })
            setLoginInfo({
                password: '',
                confirm_password: '',
            })
        }
    };

    const logout = () => {
        sessionStorage.clear();
        navigate(ROUTES.LOGIN)
    }

    const suberAdminAalidationSchema = Yup.object({
        profileImage: Yup.string().required('Please upload your profile image'),
        firstname: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Please enter your first name'),
        lastname: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Please enter your last name'),
    });

    const AdminvalidationSchema = Yup.object({
        profileImage: Yup.string().required('Please upload your profile image'),
        firstname: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Please enter your first name'),
        lastname: Yup.string()
            .max(50, 'Must be 50 characters or less')
            .required('Please enter your last name'),
        phone_number: Yup.string()
            .required('Phone number is required'),
        employee_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required'),
        emirates_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required')
            .length(15, 'Must be exactly 15 characters'),
        department_id: Yup.string()
            .matches(/^[A-Za-z0-9]+$/, 'Must be alphanumeric')
            .required('Required'),
    });

    const handleApicall = async (values: any) => {
        // console.log('Updated values:', values);
        let payload = {
            firstname: values.firstname,
            lastname: values.lastname,
            profile_image: values.profileImage
        }

        let AdminPayload = {
            firstname: values?.firstname,
            lastname: values?.lastname,
            profile_image: values?.profileImage,
            department_id: values?.department_id,
            phone_number: values?.phone_number,
            email: values?.email,
            employee_id: values?.employee_id,
            emirates_id: values?.emirates_id,
            country_code: countryFlag?.dialCode ?? "+971"
        }

        await profileUpdateApi(isSuperAdminToken === "true" ? payload : AdminPayload)
            .unwrap()
            .then((response) => {
                toast.success(response?.message, TOASTER_CONFIGS);
                navigate(ROUTES.DASHBOARD)
            })
            .catch(() => { })

    };

    const handleImageChange = async (event: any) => {
        try {
            const uploadedImage: any = await S3DataGetApi(event);
            formikRef.current.setFieldValue('profileImage', uploadedImage);
            docUploadRef.current.value = '';
        } catch (error) {
        }
    };

    return (
        <div className='profile_page_container'>
            <Grid className='change-password' container justifyContent="flex-end" alignContent='center'>
                <Button
                    variant="contained"
                    color="primary"
                    className="change_password_button"
                    onClick={() => { setDocOpen(true) }}
                >
                    Change Password
                </Button>
            </Grid>
            <Formik
                initialValues={initialValues}
                validationSchema={
                    isSuperAdminToken === "true" ? suberAdminAalidationSchema : AdminvalidationSchema}
                onSubmit={(values, actions) => {
                    handleApicall(values);
                }}
                enableReinitialize={true}
                innerRef={formikRef}
            >
                {(formik: any) => (
                    <Box
                        component="form"
                        sx={{ '& .MuiTextField-root': { m: 1, width: '100%' } }}
                        noValidate
                        autoComplete="off"
                        onSubmit={formik.handleSubmit}
                    >
                        <Grid className='form_field_inputs' spacing={2} >
                            <Grid xs={12} sm={12} className='profile_image_wrap'>
                                <Stack direction='column' alignItems='center'>
                                    <div>
                                        <input
                                            accept="image/*"
                                            style={{ display: 'none' }}
                                            id="icon-button-file"
                                            type="file"
                                            onFocus={formik.handleTouched}
                                            onBlur={formik.handleBlur}
                                            ref={docUploadRef}
                                            onChange={(event: any) => { handleImageChange(event); formik.setFieldTouched('profileImage', true) }}
                                        />
                                        <label htmlFor="icon-button-file">
                                            <IconButton component="span">
                                                <Badge
                                                    overlap="circular"
                                                    anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                                                    badgeContent={
                                                        <Box sx={[{ backgroundColor: '#f3f1f1', p: '2px', borderRadius: '50%', border: '2px solid #fff' }]}>
                                                            <PhotoCamera />
                                                        </Box>
                                                    }
                                                >
                                                    <Avatar
                                                        alt="User Avatar"
                                                        src={formik.values.profileImage}
                                                        sx={{ width: 100, height: 100 }}
                                                    />
                                                </Badge>
                                            </IconButton>
                                        </label>
                                    </div>
                                    {formik.touched.profileImage && Boolean(formik.errors.profileImage) &&
                                        <Typography color='#d32f2f' variant='caption'>{formik.errors.profileImage}</Typography>
                                    }
                                </Stack>
                            </Grid>

                            <Grid container spacing={2} className='text_input_fields'>
                                <Grid item xs={12} sm={6} className='label_inputs'>
                                    <label className='label_name' htmlFor="firstname">First Name:</label>
                                    <TextField
                                        id="outlined-controlled"
                                        name="firstname"
                                        disabled={id ? true : false}
                                        value={formik.values.firstname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.firstname && Boolean(formik.errors.firstname)}
                                        helperText={formik.touched.firstname && Boolean(formik.errors.firstname) ? formik.errors.firstname : ''}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} className='label_inputs'>
                                    <label className='label_name' htmlFor="lastname">Last Name:</label>
                                    <TextField
                                        id="outlined-controlled"
                                        name="lastname"
                                        disabled={id ? true : false}
                                        value={formik.values.lastname}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.lastname && Boolean(formik.errors.lastname)}
                                        helperText={formik.touched.lastname && Boolean(formik.errors.lastname) ? formik.errors.lastname : ''}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6} className='label_inputs'>
                                    <label className='label_name' htmlFor="email">Email:</label>
                                    <TextField
                                        id="outlined-controlled"
                                        name="email"
                                        value={formik.values.email}
                                        onChange={formik.handleChange}
                                        onBlur={formik.handleBlur}
                                        error={formik.touched.email && Boolean(formik.errors.email)}
                                        helperText={formik.errors.email}
                                        disabled={true}
                                    />
                                </Grid>

                                {isAdminToken === "true" && (
                                    <>
                                        <Grid item xs={12} sm={6} className='label_inputs'>
                                            <label className='label_name' htmlFor="email">Phone Number:</label>
                                            <Box sx={{ mt: 1 }}>
                                                <PhoneInput
                                                    inputProps={{
                                                        id: 'primary-mobile',
                                                        name: 'phone_number'
                                                    }}
                                                    inputClass='mobileInput'
                                                    country={"ae"}
                                                    countryCodeEditable={false}
                                                    enableSearch
                                                    value={formik?.values?.phone_number} // Bind Formik's value
                                                    onChange={(value, country) => {
                                                        setCountryFlag(country);
                                                        formik.setFieldValue('phone_number', value);
                                                    }} // Update Formik's value
                                                />
                                                {formik.errors.phone_number && formik.touched.phone_number && (
                                                    <div className='error'>{formik.errors.phone_number}</div>
                                                )}
                                            </Box>
                                        </Grid>

                                        <Grid item xs={12} sm={6} className='label_inputs'>
                                            <label className='label_name' htmlFor="email">Employee id:</label>
                                            <TextField
                                                id="outlined-controlled"
                                                name="employee_id"
                                                value={formik.values.employee_id}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.employee_id && Boolean(formik.errors.employee_id)}
                                                helperText={formik.errors.employee_id}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} className='label_inputs'>
                                            <label className='label_name' htmlFor="email">Emirates id:</label>
                                            <TextField
                                                id="outlined-controlled"
                                                name="emirates_id"
                                                value={formik.values.emirates_id}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                error={formik.touched.emirates_id && Boolean(formik.errors.emirates_id)}
                                                helperText={formik.errors.emirates_id}
                                            />
                                        </Grid>

                                        <Grid item xs={12} sm={6} className='label_inputs'>
                                            <label className='label_name' htmlFor="department_id">Department id:</label>
                                            <FormControl fullWidth sx={{ mt: 1, ml: 1 }}>
                                                <Select
                                                    id="demo-simple-select"
                                                    name="department_id"
                                                    value={formik?.values?.department_id}
                                                    onChange={formik.handleChange}
                                                    onBlur={formik.handleBlur}
                                                    error={formik.touched.department_id && Boolean(formik.errors.department_id)}
                                                >
                                                    {DeparmentList?.result?.data.length > 0 &&
                                                        DeparmentList?.result?.data?.map((item: any, i: any) => {
                                                            return (
                                                                <MenuItem key={i} value={item?.id}>{item?.name}</MenuItem>
                                                            )

                                                        })}
                                                </Select>
                                                {formik.touched?.department_id && formik.errors?.department_id ? (
                                                    <FormHelperText sx={{ color: '#d32f2f' }} >{formik.errors?.department_id}</FormHelperText>
                                                ) : null}
                                            </FormControl>
                                        </Grid>
                                    </>
                                )}
                            </Grid>
                        </Grid>

                        <Grid container spacing={2} justifyContent="flex-end">
                            <Grid item>
                                <Button
                                    type="button"
                                    variant="contained"
                                    color="inherit"
                                    onClick={() => { formik.resetForm(); }}
                                    sx={{ mt: 3, mb: 2 }}
                                >
                                    Cancel
                                </Button>
                            </Grid>
                            <Grid item>
                                <Button
                                    type="submit"
                                    variant="contained"
                                    sx={{ mt: 3, mb: 2, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}
                                >
                                    Save
                                </Button>
                            </Grid>
                        </Grid>
                    </Box>
                )}
            </Formik>

            <Modal
                open={docOpen}
                onClose={() => setDocOpen(false)}
                aria-labelledby="child-modal-title"
            >
                <Box sx={{ ...style, width: '60%' }}>
                    <IconButton
                        aria-label="close"
                        onClick={() => setDocOpen(false)}
                        sx={{
                            position: 'absolute',
                            zIndex: 10000,
                            top: 8,
                            right: 8,
                            color: (theme) => theme.palette.grey[500],
                            '&:hover': {
                                color: 'white',
                            },
                        }}
                    >
                        <CloseIcon />
                    </IconButton>

                    <Grid item xs={12} md={6} sx={{
                        display: 'flex',
                        alignItems: 'center',
                    }}>
                        <Container component="main" maxWidth="xs">
                            <CssBaseline />
                            <Box
                                sx={{
                                    marginTop: 8,
                                    display: 'flex',
                                    flexDirection: 'column',
                                    alignItems: 'center',
                                }}
                            >
                                <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
                                    <img src={Logo} width={50} height={50} alt='logo' />
                                </Avatar>
                                <Typography component="h1" variant="h5">
                                    Reset Your Password
                                </Typography>
                                <Box component="form" onSubmit={handleSubmit} noValidate sx={{ mt: 1 }}>

                                    <TextField
                                        name='password'
                                        onChange={(e) => kychandleChange(e.target.name, e.target.value)}
                                        onBlur={(e) => kychandleChange(e.target.name, e.target.value)}
                                        onFocus={(e) => kychandleChange(e.target.name, e.target.value)}
                                        label='Password'
                                        variant='outlined'
                                        helperText={errorMsg.password}
                                        value={loginInfo.password}
                                        error={error?.password}
                                        margin="normal"
                                        type={Visibility}
                                        fullWidth
                                        inputProps={{ inputmode: 'password' }}
                                        InputProps={Visibility === 'password' ? {
                                            endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibility('text')}><VisibilityOffOutlinedIcon /></span>
                                        } : {
                                            endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibility('password')}><VisibilityOutlinedIcon /></span>
                                        }}
                                    />
                                    <TextField
                                        name='confirm_password'
                                        onChange={(e) => kychandleChange(e.target.name, e.target.value)}
                                        onBlur={(e) => kychandleChange(e.target.name, e.target.value)}
                                        onFocus={(e) => kychandleChange(e.target.name, e.target.value)}
                                        label='Confirm password'
                                        variant='outlined'
                                        helperText={errorMsg.confirm_password}
                                        value={loginInfo.confirm_password}
                                        error={error?.confirm_password}
                                        margin="normal"
                                        type={VisibilityConfirm}
                                        fullWidth
                                        inputProps={{ inputmode: 'password' }}
                                        InputProps={VisibilityConfirm === 'password' ? {
                                            endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibilityConfirm('text')}><VisibilityOffOutlinedIcon /></span>
                                        } : {
                                            endAdornment: <span style={{ zIndex: 1000, cursor: 'pointer' }} onClick={() => setVisibilityConfirm('password')}><VisibilityOutlinedIcon /></span>
                                        }}
                                    />

                                    <Button
                                        type="submit"
                                        fullWidth
                                        variant="contained"
                                        sx={{ mt: 3, mb: 5, background: `${GLOBAL_CONSTANTS.COLOR_CODE.GRADIENT}` }}
                                    >
                                        Submit
                                    </Button>
                                </Box>
                            </Box>
                        </Container>
                    </Grid>

                </Box>
            </Modal>
        </div >
    )
}

export default ProfileComponent;
